import React from "react";
import { Box, Button, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import WarningModal from "./modals/WarningModal";

const WarningModalBox = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Warning Modal
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={
          `
          import { useState } from "react"
          import { Button, WarningModal } from "convertupleads-theme"
          
          export default function PreviewModal() {
            const [open, setOpen] = useState(false)
            return (
              <div>
                <Button onClick={() => setOpen(true)}>
                  Open modal
                </Button>
                <WarningModal
                  open={open}
                  onClose={() => setOpen(false)}
                  title='Unsaved changes'
                  warningContent='You are able to leave this page without saving. All changes will be lost.'
                ></WarningModal>
              </div>
            )
          }          
          `
          }
        >
          <Button onClick={handleOpen} color={"warning"}>
            Open warning modal
          </Button>
          <WarningModal open={open} onClose={handleClose} />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default WarningModalBox;
